import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=2b6a64ac"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"
import style0 from "./Front.vue?vue&type=style&index=0&id=2b6a64ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports